import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container block" }
const _hoisted_2 = { class: "seize row" }
const _hoisted_3 = { class: "num-time" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "detail-value" }
const _hoisted_6 = { class: "detail-value" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "detail-value" }
const _hoisted_9 = { class: "detail-value" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "table" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "table" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "table" }
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "num-time-left" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isEnterpriseProjectType === 'all')
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "detail-key" }, "项目总数：", -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.projectCount), 1),
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "detail-key" }, "打卡人数：", -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.peopleCount), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isEnterpriseProjectType === 'not')
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "detail-key" }, "派遣单位总数：", -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.serveCompanyCount), 1),
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "detail-key" }, "打卡人数：", -1)),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.servePeopleCount), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.projectTime,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.projectTime) = $event)),
          type: "daterange",
          class: "date-solt point",
          "unlink-panels": "",
          "range-separator": "至",
          "start-placeholder": _ctx.defaultStart,
          "end-placeholder": _ctx.defaultEnd,
          shortcuts: _ctx.shortcuts,
          onChange: _ctx.choiceTimeSection,
          style: {"width":"241px","margin-right":"0"}
        }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "shortcuts", "onChange"]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: _ctx.isEnterpriseProjectType === 'all'
                    ? '请输入项目/派遣单位名称'
                    : _ctx.isEnterpriseProjectType === 'not'
                        ? '请输入派遣单位名称'
                        : '请输入人员/派遣单位名称'
                    ,
          class: "input search-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchProjectText) = $event)),
          style: {"width":"176px"},
          onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.projectSearch && _ctx.projectSearch(...args)), ["enter"]))
        }, null, 40, _hoisted_10), [
          [_vModelText, _ctx.searchProjectText]
        ]),
        _createElementVNode("button", {
          class: "btn btn-width",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.projectSearch && _ctx.projectSearch(...args)))
        }, "搜索"),
        _createElementVNode("button", {
          class: "btn-white btn-width",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onProjectReset && _ctx.onProjectReset(...args)))
        }, " 重置 ")
      ])
    ]),
    _createVNode(_component_el_tabs, {
      "model-value": "all",
      onTabClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "按项目",
          name: "all"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_table, {
                data: _ctx.tableProjectData,
                style: {"width":"100%"},
                "header-row-style": { color: '#202536' },
                "row-style": { color: '#5E617D' },
                "empty-text": "请选择日期查看考勤"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "projectName",
                    label: "项目名"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "serveCompanyName",
                    label: "派遣单位名"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "signTimeStart",
                    label: "上班时间",
                    formatter: (row) =>
                            row.signTimeStart
                                ? row.signTimeStart
                                : '暂无'
                            
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    prop: "signTimeEnd",
                    label: "下班时间",
                    formatter: (row) =>
                            row.signTimeEnd ? row.signTimeEnd : '暂无'
                            
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    prop: "dayNightFlag",
                    label: "班次",
                    formatter: (row) =>
                            row.dayNightFlag === 0 ? '白班' : '夜班'
                            
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    prop: "pwCount",
                    label: "打卡人数",
                    formatter: (row) => (row.pwCount ? row.pwCount : '暂无')
                            
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    prop: "createUserName",
                    label: "项目创建人",
                    formatter: (row) =>
                            row.createUserName
                                ? row.createUserName
                                : '暂无'
                            
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    prop: "signInType",
                    label: "打卡方式",
                    formatter: (row) =>
                            row.signInMode === 0 ? '拍照打卡' : row.signInType ? 'ibeacon打卡' : '地理位置打卡'
                            
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, { label: "操作" }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("p", {
                        style: {"color":"#1989FA"},
                        class: "point",
                        onClick: ($event: any) => (
                                    _ctx.onGoProjectDetail(
                                        scope.row.id,
                                        scope.row.serveCompanyName,
                                        scope.row.projectName
                                    )
                                    )
                      }, " 查看详情 ", 8, _hoisted_12)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_el_pagination, {
                class: "pagination",
                currentPage: _ctx.projectPageNum,
                "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.projectPageNum) = $event)),
                "page-size": _ctx.projectPageSize,
                "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.projectPageSize) = $event)),
                "page-sizes": [10, 30, 50, 100],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.projectTotal,
                onSizeChange: _ctx.projectSizeChange,
                onCurrentChange: _ctx.projectHandleChange
              }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "按派遣单位",
          name: "not"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_table, {
                data: _ctx.tableEnterpriseData,
                style: {"width":"100%"},
                "header-row-style": { color: '#202536' },
                "row-style": { color: '#5E617D' },
                "empty-text": "请选择日期查看考勤"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "serveCompanyName",
                    label: "派遣单位名"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "projectCount",
                    label: "项目数"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "pwCount",
                    label: "打卡人数",
                    formatter: (row) => (row.pwCount ? row.pwCount : '暂无')
                            
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, { label: "操作" }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("p", {
                        style: {"color":"#1989FA"},
                        class: "point",
                        onClick: ($event: any) => (
                                    _ctx.onGoCompanyDetail(
                                        scope.row.serveCompanyId,
                                        scope.row.serveCompanyName,
                                        scope.row.projectName
                                    )
                                    )
                      }, " 查看详情 ", 8, _hoisted_14)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_el_pagination, {
                class: "pagination",
                currentPage: _ctx.enterpriseaPageNum,
                "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.enterpriseaPageNum) = $event)),
                "page-size": _ctx.enterpriseaPageSize,
                "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.enterpriseaPageSize) = $event)),
                "page-sizes": [10, 30, 50, 100],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.enterpriseaTotal,
                onSizeChange: _ctx.enterpriseSizeChange,
                onCurrentChange: _ctx.companyHandleChange
              }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "按个人",
          name: "alone"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_table, {
                data: _ctx.aloneList,
                style: {"width":"100%"},
                "header-row-style": { color: '#202536' },
                "row-style": { color: '#5E617D' },
                "empty-text": "请选择日期查看个人信息"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "userName",
                    label: "姓名"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "idCardNo",
                    label: "身份证"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "ppCount",
                    label: "项目次数",
                    formatter: (row) => (row.ppCount ? row.ppCount : '暂无')
                            
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    prop: "signDayCount",
                    label: "打卡天数"
                  }),
                  _createVNode(_component_el_table_column, { label: "操作" }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("p", {
                        style: {"color":"#1989FA"},
                        class: "point",
                        onClick: ($event: any) => (
                                    _ctx.onGoAloneDetail(
                                        scope.row.userId,
                                        scope.row.userName,
                                        scope.row.idCardNo
                                    )
                                    )
                      }, " 查看详情 ", 8, _hoisted_16)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_el_pagination, {
                class: "pagination",
                currentPage: _ctx.alonePageNum,
                "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.alonePageNum) = $event)),
                "page-size": _ctx.alonePageSize,
                "onUpdate:pageSize": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.alonePageSize) = $event)),
                "page-sizes": [10, 30, 50, 100],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.aloneTotal,
                onSizeChange: _ctx.aloneSizeChange,
                onCurrentChange: _ctx.getAloneQuery
              }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onTabClick"])
  ]))
}